/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Administrators
// ====================================================

export interface Administrators_administrators {
  __typename: "Administrator";
  id: string;
  companyName: string | null;
}

export interface Administrators {
  administrators: Administrators_administrators[];
}
